import { create } from "zustand";

interface RoomNoteDialogState {
    isOpen: boolean;
    globalId: string;   // The room's space product globalId
    roomName: string;
    note: string;       // Empty when the room has no note

    open: (globalId: string, roomName: string, note: string | null) => void;
    close: () => void;
}

export const useRoomNoteDialogStore = create<RoomNoteDialogState>()((set) => ({
    isOpen: false,
    globalId: "",
    roomName: "",
    note: "",

    open: (globalId, roomName, note) => set({ isOpen: true, globalId, roomName, note: note ?? "" }),
    close: () => set({ isOpen: false }),
}));
